export const SHOW_MODAL = "Modal/Show";
export const HIDE_MODAL = "Modal/Hide";
